
import { ArtistTrackModel } from '@/models'
import { setSeoMeta } from '@/seo'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Album extends Vue {
    loader = true

    get album () {
        return this.$store.getters['trackModule/getTracks'] ? this.$store.getters['trackModule/getTracks']: []
    }

    get albumItem () {
        return this.album[0] || null
    }

    get albumTracks () {
        return this.albumItem && this.albumItem.tracks ? this.albumItem.tracks : []
    }

    get audio () {
        return this.$store.getters['getAudio']
    }

    get current() {
        return this.$store.getters['getCurrent']
    }

    coverStyle(image?: string, name?: string) {
        if (image && image.trim() && image.indexOf('url("")') === -1) {
            return { backgroundImage: `url(${image})` }
        }
        const str = name || 'fallback';
        let hash = 0;
        for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
        const hue = Math.abs(hash) % 360;
        return {
            backgroundImage: `linear-gradient(135deg, hsl(${hue}, 70%, 20%), hsl(${(hue + 40) % 360}, 80%, 15%))`
        }
    }

    playSong (track: ArtistTrackModel, queue: ArtistTrackModel[]) {
        this.audio.playbackRate = 1
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', queue)
        this.$store.commit('playTrack', track)
        this.audio.play();
    }

    playAlbum() {
        if (!this.albumTracks.length) {
            return
        }
        this.$store.commit('setTracksQueue', this.albumTracks)
        this.$store.commit('playTrack', this.albumTracks[0])
        this.audio.src = this.albumTracks[0].audio
        this.audio.play()
    }

    convertTime (secs: number | string) {
        const totalSec = Math.floor(Number(secs) || 0);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }

    updateAlbumSeo() {
        const album = this.albumItem
        if (!album || !album.name) {
            return
        }

        const artistName = album.artist_name || 'independent artist'
        setSeoMeta({
            title: `${album.name} by ${artistName} | Robopol Music`,
            description: `Stream ${album.name} by ${artistName} on Robopol Music. Browse album tracks and download available songs.`,
            path: this.$route.path,
            heading: album.name,
            summary: `Listen to ${album.name} by ${artistName} on Robopol Music.`,
            image: album.image,
            imageAlt: `${album.name} album cover`,
            schemaType: 'MusicAlbum',
        })
    }

    mounted () {
        window.scrollTo(0,0);
        this.$store.dispatch('trackModule/fetchAlbumTracks', this.$route.params.id).then((response: ArtistTrackModel[]) => {
            this.loader = false
            if (!response || !response[0] || !response[0].tracks) {
                return
            }
            response[0].tracks.map((track: ArtistTrackModel) => {
                track['artist_name'] = response[0].artist_name
                track.image = response[0].image
            })
            this.updateAlbumSeo()
        }).catch(() => {
            this.loader = false
        })
    }
}
